import { useMemo } from 'react'

import { Dropdown, Tooltip } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useBlockType } from '../../hooks/useBlockType'
import { useRichEditorStore } from '../../Store/hooks/useStore'
import { useBaseStyles } from '../../themes/base/style'
import { DropdownButton } from '../../ui/DropdownButton'

export const BlockTypeDropdown = () => {
  const { blockTypeList, blockTypeShortcuts } = useRichEditorStore(state =>
    pick(state, ['blockTypeList', 'blockTypeShortcuts'])
  )
  const [blockType, setBlockType] = useBlockType()

  const editorStyles = useBaseStyles()

  const items = useMemo(
    () =>
      blockTypeList.map(({ tag, label, value }) => {
        const Wrapper = tag
        const labelNode = (
          <Wrapper className={editorStyles[value]} style={{ margin: 0 }}>
            {label}
          </Wrapper>
        )
        return {
          key: value,
          label: (
            <Tooltip placement='right' title={blockTypeShortcuts[value]}>
              {labelNode}
            </Tooltip>
          )
        }
      }),
    [blockTypeList, blockTypeShortcuts, editorStyles]
  )

  const selectedItem = blockTypeList.find(item => item.value === blockType)

  return (
    <Dropdown
      menu={{
        items: items,
        selectedKeys: [blockType],
        onClick: ({ key }) => {
          setBlockType({ type: key as any, resetIfSame: true })
        }
      }}
    >
      <DropdownButton>
        <span style={{ display: 'inline-block', width: '3em' }}>
          {selectedItem?.label}
        </span>
      </DropdownButton>
    </Dropdown>
  )
}
